/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRoad = createReactComponent("road", "IconRoad", [
  ["path", { d: "M4 19l4 -14", key: "svg-0" }],
  ["path", { d: "M16 5l4 14", key: "svg-1" }],
  ["path", { d: "M12 8v-2", key: "svg-2" }],
  ["path", { d: "M12 13v-2", key: "svg-3" }],
  ["path", { d: "M12 18v-2", key: "svg-4" }]
]);

export { IconRoad as default };
//# sourceMappingURL=IconRoad.js.map
